import { render } from "./ServicesGlobal.vue?vue&type=template&id=4032a014"
import script from "./ServicesGlobal.vue?vue&type=script&lang=js"
export * from "./ServicesGlobal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__